<div style="font-size: 15px; font-weight: 500;">
  {{ title }}
  <mat-divider
    [ngStyle]="{ width: '90%' }"
    ngStyle.lt-lg="{ width: '100%' }"
  ></mat-divider>
</div>
<mat-list
  class="file-list"
  [ngStyle]="{ width: '90%' }"
  ngStyle.lt-lg="{ width: '100%' }"
  ngStyle.lt-md="{ 'margin-bottom': '28x' }"
>
  <mat-list-item *ngFor="let item of taskItems">
    <div
      matLine
      style="display: inline-block !important; width: 100%;"
      ngStyle.gt-sm="{ 'margin-bottom': '12px' }"
      ngStyle.lt-md="{ 'margin-bottom': '36px' }"
    >
      <div
        fxLayout="row"
        fxLayout.lt-md="column wrap"
        ngStyle.gt-sm="{ 'margin-top': '9px' }"
      >
        <div fxFlex="45%" ngStyle.lt-md="{ width: '100%' }">
          <div
            class="text-ellipsis"
            [title]="getName(item.recipients)"
            style="font-size: 18px; font-weight: 400;"
          >
            {{ getName(item.recipients) }}
          </div>

          <div class="text-ellipsis">
            <div *ngIf="CanShowWhy(item)">
              <div style="font-size: 14px;">
                <span class="warn-text"> Action required </span>
                <span>
                  (<a
                    style="color: #29637C; font-size: 14px;"
                    href="javascript:void(0)"
                    (click)="onClickShowReasonWhy(item.reasonWhy)"
                    >read why</a
                  >)
                </span>
              </div>
            </div>
            <div >
              <small>{{ getStatus(item) }}</small>
            </div>
          </div>
        </div>

        <div fxFlex="40%" ngStyle.lt-md="{ width: '100%' }" style="padding: 12px;" >
          <div *ngIf="item.statusCode === 700000000  && item.recipients !== null && item.recipients.length > 0 && item.recipients[0].sg4506CRequestType !== 700000001">
            <div *ngFor="let recipient of item.recipients">
              <div
                *ngIf="
                  recipient.recipientStatus === 700000000 &&
                  item.statusCode === 700000000
                "
              >
                <button
                  mat-flat-button
                  color="primary"
                  style="margin-top: 12px; text-transform: uppercase;"
                  (click)="goToLink(recipient, item)"
                  disabled ="{{disablebuttton}}"

                >
                  <span *ngIf="recipient.primary && item.recipients.length > 1"
                    >COMPLETE THE FORM: MAIN</span
                  >
                  <span *ngIf="recipient.primary && item.recipients.length == 1"
                    >COMPLETE THE FORM</span
                  >
                  <span *ngIf="!recipient.primary"
                    >COMPLETE THE FORM: SPOUSE</span
                  >

                </button>
              </div>
              <div 
                *ngIf="
                  recipient.recipientStatus === 700000004 &&
                  !application.envelopeOkToVerify
                "
              >
                <span>READY TO SUBMIT</span>
              </div>
            </div>
          </div>
          <div *ngIf="item.statusCode === 700000000 && item.recipients !== null && item.recipients.length > 0 && item.recipients[0].sg4506CRequestType === 700000001 && item.recipients[0].verificationSubmitted === null">
            <button
              mat-flat-button
              color="primary"
              style="margin-top: 12px; text-transform: uppercase;"
              (click)="onClickSubmitTaxRequestData(item)"  [disabled]="CheckAny4506cCanceledItems()">
              <span>SUBMIT</span>
            </button>
          </div>          
          <div *ngIf="CheckAnyRejected4506cItemsDisplayed(item)">
            <button
              mat-flat-button
              color="primary"
              style="margin-top: 12px; text-transform: uppercase;"
              (click)="onClickResubmitTaxRequestData(item)"  [disabled]="CheckAny4506cCanceledItems()">
              <span>RESUBMIT</span>
            </button>
          </div>
          <div *ngIf="CheckAny4506cCanceledItem(item)">
            <span>CANCELED BY IRS</span>
          </div>
          <div *ngIf="item.statusCode === 700000002 && item.recipients== null">
            <button
              mat-flat-button
              color="primary"
              style="margin-top: 12px; text-transform: uppercase;"
              (click)="onClickSubmitTaxRequestData(item)" [disabled]="CheckAny4506cCanceledItems()">
              <span>SUBMIT</span>
            </button>
          </div>

          <div *ngIf="item.statusCode !== 700000002" >
            <span>{{ getDocustatus(item) }}
              <ng-container *ngIf="getDocustatus(item) === 'WAITING FOR IRS ACTION'">
              <button 
                type="button"
                (click)="openIrsInfoDialog()"
                style="background:none;color:#377491; border:none; cursor:pointer;"
                aria-label="More info"
                title="More info"
              >
              <i class="fa-solid fa-circle-info"></i>
              </button>
             
             
            </ng-container>


            </span>
          </div>
        </div>
        <div fxFlex="15%" ngStyle.lt-md="{ width: '100%' }" >
          <div *ngIf="IsOkToDelete(item)">
          <button   mat-flat-button
          color="warn"
          style="margin-top: 12px;text-transform: uppercase;"
          (click)="onDeleteEvent(item.id)"
        >
        
          <span>DELETE</span
          >
        </button>
      </div>
        
        </div>
      </div>
    </div>
<mat-divider fxShow ></mat-divider>

  </mat-list-item>
</mat-list>
